import styled from "styled-components";
import Box from "../../../layout/boxes/Box";

import { StyledCircularStepperCircleProps } from "../CircularStepper.types";
import { Circle } from "./svg";

const TRANSITION_DURATION = "300ms";
const TRANSITION_TIMING_FUNCTION = "linear";

const CIRCLE_DIMENSION = 64;
const CIRCLE_STROKE_DASH_ARRAY = 189.495; // 2 * PI * r
const CIRCLE_STROKE_WIDTH = 4;

export const StyledCircularStepperProgress = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	width: ${CIRCLE_DIMENSION}px;
	height: ${CIRCLE_DIMENSION}px;
	margin-right: ${({ theme }) => theme.space.md};

	::before {
		content: "";
		display: block;
		position: absolute;
		border: ${CIRCLE_STROKE_WIDTH}px solid
			${({ theme }) => theme.palette.hexForMandatory("primary_accent_200")};
		border-radius: ${CIRCLE_DIMENSION / 2}px;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
	}
`;

export const StyledCircularStepperCircle = styled(
	({ completedStepCount, stepCount, ...props }) => <Circle {...props} />
)<StyledCircularStepperCircleProps>`
	display: block;
	position: absolute;
	transform: rotate(-90deg);
	transition: stroke-dashoffset ${TRANSITION_DURATION}
			${TRANSITION_TIMING_FUNCTION},
		stroke ${TRANSITION_DURATION} ${TRANSITION_TIMING_FUNCTION};

	${({ theme, stepCount, completedStepCount }) => {
		const COLOR_HEX_PRIMARY_ACCENT_600 =
			theme.palette.hexForMandatory("primary_accent_600");
		const COLOR_HEX_SEMANTIC_SUCCESS_500 = theme.palette.hexForMandatory(
			"semantic_success_500"
		);

		const PROGRESS_SEGMENT = CIRCLE_STROKE_DASH_ARRAY / stepCount;
		const TOTAL_PROGRESS =
			CIRCLE_STROKE_DASH_ARRAY - (completedStepCount + 1) * PROGRESS_SEGMENT;
		const isCompleted = completedStepCount >= stepCount;

		return {
			strokeDasharray: CIRCLE_STROKE_DASH_ARRAY,
			strokeWidth: CIRCLE_STROKE_WIDTH,
			strokeDashoffset: isCompleted ? 0 : TOTAL_PROGRESS,
			stroke: isCompleted
				? COLOR_HEX_SEMANTIC_SUCCESS_500
				: COLOR_HEX_PRIMARY_ACCENT_600,
		};
	}}
`;

export const StyledCircularStepperSteps = styled(Box)`
	display: block;
	position: relative;
	flex: 1;
`;
